import { Box } from '@npco/zeller-design-system'
import { DownloadMessage } from 'features/StartupModals/SetupFlow/components/DownloadMessage/DownloadMessage'

import { ReactComponent as ArrowBadge } from 'assets/svg/setup-flow/arrow.svg'
import { ReactComponent as QRCode } from 'assets/svg/setup-flow/download-QR-code.svg'

export const DownloadLinkDesktop = () => {
  return (
    <Box
      data-testid="download-link-desktop"
      position="relative"
      margin="-10px 0"
      textAlign="center"
    >
      <Box display="inline-block" position="relative">
        <QRCode />

        <Box position="absolute" right="-84px" bottom="70px">
          <ArrowBadge />
        </Box>

        <Box
          position="absolute"
          bottom="8px"
          right="-180px"
          maxWidth="162px"
          textAlign="left"
        >
          <DownloadMessage />
        </Box>
      </Box>
    </Box>
  )
}
